import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';

import { Box, List, ListItem, SxProps, Theme, Typography } from '@mui/material';

const ROI_HORIZON_STRINGS = appStrings.modules.charts.returnOnInvestment.roiHorizonModal;

export const ROIHorizonModalContent = () => {
  return (
    <Box sx={containerSx}>
      {/* What it is */}
      <Box sx={sectionSx}>
        <Typography variant="text-sm-bold">{ROI_HORIZON_STRINGS.whatItIs.title}</Typography>
        {ROI_HORIZON_STRINGS.whatItIs.paragraphs.map((paragraph, index) => (
          <Typography key={index} variant="text-sm-regular" sx={paragraphSx}>
            {paragraph}
          </Typography>
        ))}
      </Box>

      {/* Why it matters */}
      <Box sx={sectionSx}>
        <Typography variant="text-sm-bold">{ROI_HORIZON_STRINGS.whyItMatters.title}</Typography>
        {ROI_HORIZON_STRINGS.whyItMatters.paragraphs.map((paragraph, index) => (
          <Typography key={index} variant="text-sm-regular" sx={paragraphSx}>
            {paragraph}
          </Typography>
        ))}
        <List sx={bulletListSx}>
          {ROI_HORIZON_STRINGS.whyItMatters.bulletPoints.map((point, index) => (
            <ListItem key={index} sx={bulletItemSx}>
              <Typography variant="text-sm-regular">{point}</Typography>
            </ListItem>
          ))}
        </List>
        <Typography variant="text-sm-regular" sx={paragraphSx}>
          {ROI_HORIZON_STRINGS.whyItMatters.additionalParagraph}
        </Typography>
      </Box>

      {/* How it is calculated */}
      <Box sx={sectionSx}>
        <Typography variant="text-sm-bold">
          {ROI_HORIZON_STRINGS.howItIsCalculated.title}
        </Typography>
        {ROI_HORIZON_STRINGS.howItIsCalculated.paragraphs.map((paragraph, index) => (
          <Typography key={index} variant="text-sm-regular" sx={paragraphSx}>
            {paragraph}
          </Typography>
        ))}
        <List sx={bulletListSx}>
          {ROI_HORIZON_STRINGS.howItIsCalculated.bulletPoints.map((point, index) => (
            <ListItem key={index} sx={bulletItemSx}>
              <Typography variant="text-sm-regular">{point}</Typography>
            </ListItem>
          ))}
        </List>
        <Typography variant="text-sm-regular" sx={paragraphSx}>
          {ROI_HORIZON_STRINGS.howItIsCalculated.conclusion}
        </Typography>
        <Typography variant="text-sm-regular" sx={paragraphSx}>
          {ROI_HORIZON_STRINGS.howItIsCalculated.source}
        </Typography>
      </Box>
    </Box>
  );
};

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-lg'],
});

const sectionSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-xs'],
});

const paragraphSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-secondary'],
});

const bulletListSx: SxProps<Theme> = ({ backrs }) => ({
  margin: 0,
  paddingLeft: backrs.spacing['spacing-2xl'],
  listStyleType: 'disc',
});

const bulletItemSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'list-item',
  padding: 0,
  paddingLeft: backrs.spacing['spacing-xs'],
  color: backrs.colors['Colors/Text/text-secondary'],
});
